import { useState } from 'react';

import Tabs from '../../tabs/tabs';
import formatDate from '../../../helpers/format-date';
import IconLoader from '../../icons/loader';
import { BlacklistUserInfoTypes } from './types';
import BlacklistUserInfoGeneral from './user-info-general';
import BlacklistUserInfoRiskSegments from './user-info-risk-segments';
import BlacklistUserInfoGeneralBlock from './user-info-general-block';
import BlacklistUserInfoAdditionalSegments from './additional-segments';
import { soesColumns } from './variables/general';

import cn from './blacklist.module.css';

const BlacklistUserInfo = ({ info, isLoading }: BlacklistUserInfoTypes) => {
  const [activeTab, setActiveTab] = useState<
    'general' | 'risk' | 'soe' | 'additional'
  >('general');

  let content = (
    <div className={cn.userInfoLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading && info) {
    content = (
      <>
        <div className={cn.userInfoTop}>
          <div className={cn.userInfoTitle}>
            <div className={cn.userInfoName}>{info?.source?.name}</div>
            <div className={cn.userInfoValue}>
              {info?.source?.entityTypeDesc}
            </div>
            <div className={cn.userInfoValue}>{info?.source?.gender}</div>
          </div>
          <div className={cn.userEntityInfo}>
            <div className={cn.userEntityInfoValue}>
              <div className={cn.userEntityInfoValueTitle}>EntityGUID</div>
              <div className={cn.userEntityInfoValueDescription}>
                {info?.source?.entityGUID}
              </div>
            </div>
            <div className={cn.userEntityInfoValue}>
              <div className={cn.userEntityInfoValueTitle}>EntityID</div>
              <div className={cn.userEntityInfoValueDescription}>
                {info?.source?.entityID}
              </div>
            </div>
            <div className={cn.userEntityInfoValue}>
              <div className={cn.userEntityInfoValueTitle}>LookupID</div>
              <div className={cn.userEntityInfoValueDescription}>
                {info?.source?.lookupID}
              </div>
            </div>
            <div className={cn.userEntityInfoValue}>
              <div className={cn.userEntityInfoValueTitle}>LastUpdated</div>
              <div className={cn.userEntityInfoValueDescription}>
                {info?.source?.lastUpdated
                  ? formatDate(info?.source?.lastUpdated)
                  : '—'}
              </div>
            </div>
            <div className={cn.userEntityInfoValue}>
              <div className={cn.userEntityInfoValueTitle}>Deceased</div>
              <div className={cn.userEntityInfoValueDescription}>
                {info?.source?.isDeceased === '1' ? 'Yes' : 'No'}
              </div>
            </div>
          </div>
        </div>
        <Tabs
          tabs={[
            {
              name: 'General Info',
              value: 'general',
            },
            {
              name: 'Risk-segments',
              value: 'risk',
            },
            {
              name: 'SOE / SWF',
              value: 'soe',
            },
            {
              name: 'Additional Segments',
              value: 'additional',
            },
          ]}
          activeTab={activeTab}
          wrapperClassName={cn.clientTabs}
          onClick={(tab) => {
            setActiveTab(tab as 'general' | 'risk' | 'soe' | 'additional');
          }}
          withSticky
        />
        {activeTab === 'general' && <BlacklistUserInfoGeneral info={info} />}
        {activeTab === 'risk' && <BlacklistUserInfoRiskSegments info={info} />}
        {activeTab === 'soe' && (
          <div className={cn.userInfoContent}>
            <div className={cn.userInfoContentBlock}>
              <BlacklistUserInfoGeneralBlock
                info={info?.source?.entitySegments?.entitySOEs}
                columns={soesColumns}
                withoutTitle
              />
            </div>
          </div>
        )}
        {activeTab === 'additional' && (
          <BlacklistUserInfoAdditionalSegments info={info} />
        )}
      </>
    );
  }

  return content;
};

export default BlacklistUserInfo;
